import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import backofficeApiClient, {
  LandingPageQuestionForm,
  LandingStatisticProfileType,
} from 'api/backofficeApiClient';

interface CommunicationState {}

const initialState: CommunicationState = {};

const sendCallRequest = createAsyncThunk(
  'communication/sendCallRequest',
  async (data: LandingPageQuestionForm) => {
    return backofficeApiClient.sendLetUsCallYouForm(data);
  },
);

const sendQuestion = createAsyncThunk(
  'communication/sendQuestion',
  async (data: LandingPageQuestionForm) => {
    return backofficeApiClient.sendQuestionForm(data);
  },
);

const saveRepresentChoise = createAsyncThunk(
  'communication/saveRepresentChoise',
  async (profileType: LandingStatisticProfileType) => {
    return backofficeApiClient.incrementProfileTypeCount(profileType);
  },
);

const communicationSlice = createSlice({
  name: 'communication',
  initialState,
  reducers: {},
});

const { reducer } = communicationSlice;

export { sendCallRequest, sendQuestion, saveRepresentChoise };

export default reducer;
